module.exports = __webpack_public_path__ + "img/right_arrow.e3d2cd14.svg";